
// PATHS
import axios from "axios";

const SEARCH_DOCUMENTS = '/network/documentHistory/search';

const searchDocuments: any = async (req: any) => {
    const response = await axios.post(SEARCH_DOCUMENTS, req);
    return response.data;
}
export {
    searchDocuments
}